globalThis.WeakRef ??= class {
  target = null
  constructor (target) {
    this.target = target
  }

  deref () {
    return this.target
  }
}
